import React from "react";
import { FlatList, StyleSheet, View } from "react-native";
import S3Image from "screens/common/S3Image";
import { getFAImage } from "screens/Profile/utils";
import SText from "styled42/components/SText";
import SClickableArea from "styled42/components/SClickableArea";
import { Colors } from "styled42/config";
import VernacManager from "utils/vernacular";

const FAList = ({
  title,
  titleProps,
  faList,
  selectedFAIds,
  onSelect,
  showListItemImage = false,
  listKey = "list"
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <SText {...titleProps}>{title}</SText>
      </View>
      <FlatList
        extraData={selectedFAIds}
        data={faList}
        ItemSeparatorComponent={false}
        keyExtractor={(item) => `${listKey}-${item.id}`}
        renderItem={({ item }) => {
          const selected = selectedFAIds.indexOf(item.id) > -1;
          return (
            <SClickableArea
              containerStyle={[
                styles.faContainer,
                selected ? styles.faContainerSelected : styles.faContainerNormal
              ]}
              onClick={() => {
                onSelect(item, selected, listKey);
              }}
            >
              {showListItemImage ? (
                <S3Image imageUrl={getFAImage(item.id)} style={styles.faIcon} />
              ) : null}
              <SText
                size={14}
                weight={selected ? "500" : "300"}
                color={selected ? "#050F24" : "#696F7C"}
                containerStyle={styles.faText}
              >
                {VernacManager.translateString(item.name) || item?.name}
              </SText>
              {selected && (
                <View style={[styles.selectedContainer, styles.tickContainer]}>
                  <View style={styles.tick} />
                </View>
              )}
            </SClickableArea>
          );
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 16
  },

  selectedContainer: {
    alignItems: "center",
    justifyContent: "center",
    width: 14,
    height: 14,
    borderRadius: 4
  },

  tick: {
    transform: [{ rotate: "45deg" }],
    height: 8,
    width: 5,
    borderColor: Colors.White[1],
    borderBottomWidth: 2,
    borderRightWidth: 2,
    marginBottom: 2
  },
  tickContainer: {
    backgroundColor: "#FF9518",
    right: 0,
    top: 0,
    width: 20,
    height: 20,
    borderRadius: 10
  },
  headerContainer: {
    paddingTop: 16,
    paddingBottom: 8,
    paddingHorizontal: 16
  },
  faContainer: {
    margin: 6,
    marginHorizontal: 16,
    height: 56,
    paddingLeft: 16,
    paddingRight: 18,
    flexDirection: "row",
    alignItems: "center",
    borderColor: "#F2F3F4",
    borderWidth: 1,
    borderRadius: 8,
    backgroundColor: "#FFFFFF"
  },
  faContainerNormal: {
    borderColor: "#F2F3F4",
    backgroundColor: "#FFFFFF"
  },
  faContainerSelected: {
    borderColor: "#FF8718",
    backgroundColor: "#FFF3E8"
  },
  faIcon: {
    width: 32,
    height: 32,
    marginRight: 16,
    borderRadius: 16
  },
  faText: {
    flex: 1
  },
  tickIcon: {
    width: 16,
    height: 16
  }
});

export default FAList;
